<template>
  <div id="instrument-operation">
    <common-search :searchList="searchList" @onSearch="onSearch" type="batch"></common-search>

    <common-table 
      :product_list="batch_list" 
      :loading="loading" 
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_generate"
      title="万森文创兑换码生成表"
      type="batch"
      height="650"
      :newCheckHeader="checkedHeaders"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  name: 'instrument-operation',
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  data() {
    return {
      loading: false,
      batch_list: null,
      searchList: {
        batchName: '', createTime: '',expireTime: ''
      },
      tableHandler: [],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      uploading: '',
      checkedHeaders: ['批次名称', '批次创建日期','批次过期时间','兑换码总数'],
    }
  },
  async mounted(){
    this.getMessageByPage();
  },
  watch: {
  },
  methods: {
    async getMessageByPage(){
      this.loading = true;

      let borrowType = 'admin_now';

      let options = this.$util.formatOptions(this.searchList);

      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const batch_list = await this.$request.get_batches(this.currentPage,this.pageSize,options);

      this.batch_list = batch_list.data;
      this.total = batch_list.total
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-operation{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/BorrowSituation.vue